import { render } from "./PageSwitcher.vue?vue&type=template&id=d12ed740&scoped=true"
import script from "./PageSwitcher.vue?vue&type=script&lang=js"
export * from "./PageSwitcher.vue?vue&type=script&lang=js"

import "./PageSwitcher.vue?vue&type=style&index=0&id=d12ed740&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d12ed740"]])

export default __exports__